export { GoogleTagServerSide, sendEvent } from './GoogleTagServerSide';
